import React from "react";

import UnsubscriptionsTrialPeriodTable from "../UnsubscriptionsTrialPeriodTable";
import TrialUnsubscriptionsCard from "./TrialUnsubscriptionsCard";
import UnsubscribeReasonsCard from "./UnsubscribeReasonsCard";
import UnsubscriptionsByOfferCard from "./UnsubscriptionsByOfferCard";
import UnsubscriptionsKpiGrid from "./UnsubscriptionsKpiGrid";
import UnsubscriptionsTimelineCard from "./UnsubscriptionsTimelineCard";

import type { JSX } from "react";

import type { OfferAnalyticsFilterProps } from "../offerAnalytics.types";

function UnsubscriptionsTab({
  filters,
}: OfferAnalyticsFilterProps): JSX.Element {
  return (
    <div className="flex flex-col gap-4">
      <UnsubscriptionsKpiGrid filters={filters} />
      <UnsubscriptionsTimelineCard filters={filters} />
      <div className="grid gap-4 @3xl:grid-cols-2">
        <UnsubscriptionsByOfferCard filters={filters} />
        <UnsubscribeReasonsCard filters={filters} />
      </div>
      <TrialUnsubscriptionsCard filters={filters} />
      <UnsubscriptionsTrialPeriodTable filters={filters} />
    </div>
  );
}

export default UnsubscriptionsTab;
